"use strict";
import "src/decidim/participatory_documents/participatory_documents_application.js";
import "entrypoints/decidim_participatory_documents.scss";
require.context("../images", true);
